module.exports = __webpack_public_path__ + "img/03_full.6c6322db.jpg";